












import Vue from 'vue'
import MainMenu from './components/MainMenu.vue'
import BackButton from './components/BackButton.vue'
import SkipToContent from './components/SkipToContent.vue'
import ImagePopup from './components/ImagePopup.vue'
import { EventBus } from './utils'

interface CMethods {
  scrollToTop(): void
}

export default Vue.extend<{}, CMethods, {}, {}>({
  name: 'App',
  components: {
    BackButton,
    MainMenu,
    SkipToContent,
    ImagePopup
  },
  mounted() {
    EventBus.$on('scroll-to-top', () => this.scrollToTop())
  },
  methods: {
    scrollToTop() {
      let wrapper = this.$refs.appWrapper as HTMLDivElement
      wrapper.scrollTo(0,0);
    }
  }
})
